import React from 'react'
import { Box, Button, Typography, useMediaQuery } from '@material-ui/core'
import { useIntl } from 'gatsby-plugin-intl'
import scrollTo from 'gatsby-plugin-smoothscroll'
import { useStyles } from './ProductInfo.style'
import LinkWithIcon from '../LinkWithIcon'
import { resolveImageUrlForDeviceAndLocale } from '../../utils/resolveImageUrlForDeviceAndLocale'

const ProductInfoVariationFortyAfterSales = (props) => {
  const styles = useStyles()
  const { locale } = useIntl()
  const { t } = props

  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('sm'))

  let content
  if (props.subType === 'cta') {
    content = (
      <Box
        style={{
          backgroundImage: `url(${props.imageUrl})`,
        }}
        className={styles.fortyVariantAfterSalesRoot}
      >
        <Box>
          {props.icon && (
            <Box className={styles.fortyVariantIconAfterSales}>
              {props.icon}
            </Box>
          )}
          {props.title && (
            <Typography
              variant="h1"
              className={styles.fortyVariantTitleAfterSales}
            >
              {t(props.title)}
            </Typography>
          )}
          {props.ctaType === 'button' && (
            <Button
              className={styles.fortyVariantButtonAfterSales}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (props.scrollTo) {
                  scrollTo(props.scrollTo)
                }
              }}
            >
              {t(props.ctaTitle)}
            </Button>
          )}
          {props.ctaType === 'link' && (
            <Box className={styles.fortyVariantLinkAfterSales}>
              <LinkWithIcon text={t(props.ctaTitle)} to={props.ctaLink} />
            </Box>
          )}
        </Box>
      </Box>
    )
  } else if (props.subType === 'image') {
    content = (
      <Box className={styles.fortyVariantImageAfterSalesRoot}>
        {' '}
        <Box
          className={styles.variantImageAfterSales}
          style={{ width: props.customWidth ? props.customWidth : '200px' }}
        >
          {props.title && (
            <Typography
              variant="h1"
              className={styles.fortyVariantTitleAfterSales}
            >
              {t(props.title)}
            </Typography>
          )}
          <img
            src={resolveImageUrlForDeviceAndLocale(
              props.imageUrl,
              locale,
              isDesktop,
              props.imageShouldSwitchLocale,
            )}
          />
        </Box>
      </Box>
    )
  }

  return <>{content}</>
}

export default ProductInfoVariationFortyAfterSales
